import React, { useEffect, useMemo, useState } from 'react';
import { ClipboardCheck, FileText, AlertTriangle } from 'lucide-react';
import { fmtDate, portalApi, portalFileUrl } from './portalApi';
import { Card, Empty, PageHeader, Pill, Spinner, WoChip } from './portalUi';

const statusTone = (s) => { const v = (s || '').toLowerCase(); return v.includes('fail') || v.includes('defic') ? 'expired' : v.includes('pass') || v.includes('ok') || v.includes('complete') ? 'valid' : 'info'; };

export default function PortalInspections() {
  const [rows, setRows] = useState(null);
  const [type, setType] = useState('');
  useEffect(() => { portalApi.get('/inspections').then((r) => setRows(r.data)); }, []);
  const types = useMemo(() => rows ? [...new Map(rows.map((r) => [r.type, r.label])).entries()] : [], [rows]);
  if (!rows) return <Spinner />;
  const shown = rows.filter((r) => !type || r.type === type);

  return (
    <div data-testid="portal-inspections">
      <PageHeader overline="Equipment inspections" title="Inspection & permit records" subtitle="Daily pre-shift inspections, equipment checks and permits our crew completed on your work orders. Open the signed PDF for your records."
        actions={<select className="p-input !w-auto" value={type} onChange={(e) => setType(e.target.value)} data-testid="inspection-type-filter">
          <option value="">All types</option>{types.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>} />
      <Card>
        {shown.length === 0 ? <Empty icon={ClipboardCheck} title="No inspection records yet" text="Inspections are filed from the crew's tablets; they appear here as soon as they are submitted against your work order." /> : (
          <div className="overflow-x-auto p-scroll"><table className="p-table" data-testid="inspection-table">
            <thead><tr><th>Date</th><th>Inspection</th><th>Work order</th><th>Equipment</th><th>Inspector</th><th>Result</th><th></th></tr></thead>
            <tbody>{shown.map((r) => (
              <tr key={r.id} data-testid={`inspection-row-${r.id}`}>
                <td className="whitespace-nowrap"><span className="p-mono">{fmtDate(r.date)}</span>{r.time && <span className="text-xs text-slate-400 ml-1">{r.time}</span>}</td>
                <td className="font-semibold text-slate-900">{r.label}{r.job_site && <div className="text-xs text-slate-400 font-normal">{r.job_site}</div>}</td>
                <td><WoChip wo={r.work_order_number} title={r.title} /></td>
                <td className="text-slate-600">{r.equipment || <span className="text-slate-300">—</span>}</td>
                <td>{r.inspector}</td>
                <td>
                  <div className="flex items-center gap-1.5 flex-wrap">
                    {r.status && <Pill tone={statusTone(r.status)}>{r.status}</Pill>}
                    {r.deficiencies && <Pill tone="expiring"><AlertTriangle className="w-3 h-3" /> deficiency noted</Pill>}
                  </div>
                  {r.corrective_actions && <div className="text-xs text-slate-500 mt-1 max-w-xs">{r.corrective_actions}</div>}
                </td>
                <td className="!text-right"><a className="p-btn p-btn-ghost !py-1 !px-2.5 text-xs" href={portalFileUrl(`/inspections/${r.id}/pdf`)} target="_blank" rel="noreferrer" data-testid={`inspection-pdf-${r.id}`}><FileText className="w-3.5 h-3.5" /> PDF</a></td>
              </tr>))}</tbody>
          </table></div>)}
      </Card>
    </div>
  );
}
